"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ComposerTemplates.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _useTemplatePickerRows = require('shared/hooks/templates/useTemplatePickerRows');



var _templateComposer = require('shared/services/templateComposer');
var _templateInsert = require('shared/services/templateInsert');
var _templateResolver = require('shared/services/templateResolver');

var _useLatestTemplate = require('web/components/MessageTemplates/useLatestTemplate');
var _TemplatesDialog = require('web/components/MessageTemplates/TemplatesDialog'); var _TemplatesDialog2 = _interopRequireDefault(_TemplatesDialog);

var _TemplatePicker = require('./TemplatePicker'); var _TemplatePicker2 = _interopRequireDefault(_TemplatePicker);

/* What's open: the inline list from "/" typed into an empty field (the draft
 * after "/" is the query), or the Templates dialog (+ → Templates, the
 * Templates shortcut, or "Manage templates…" at the bottom of the "/" list). */




const NO_CHIPS = []
// How long "Updated by Jo R. just now" stays above the field.
 const NOTICE_MS = 4000; exports.NOTICE_MS = NOTICE_MS
// How long a value flashes after Enter or Send jumps to it.
 const FLASH_MS = 900; exports.FLASH_MS = FLASH_MS
















/* Lane D's part of the conversation composer: the Templates action opens the
 * Templates dialog and the "/" trigger the inline list; a picked template goes in with the chat's
 * values filled and its first chip selected; Tab and Shift-Tab move between
 * chips; and Send and Send later stay off while any {{…}} is left (rule A10).
 * Only the picker reads the store, and it mounts only while open. */
 const useComposerTemplates = ({
  orgKey, blobjectKey, value, fromTemplate, onFromTemplateChange: setFromTemplate, composer, maxLength, onTooLong,
}) => {
  const [mode, setMode] = _react.useState(null)
  // What the dialog's search starts with ("Manage templates…" from "/app" carries "app").
  const [dialogQuery, setDialogQuery] = _react.useState.call(void 0, '')
  const pickerKeys = _react.useRef(null)
  // A quiet line above the field for a few seconds, e.g. "Updated by Jo R. just now".
  const [notice, setNotice] = _react.useState(null)
  const noticeTimer = _react.useRef(null)
  const showNotice = _react.useCallback.call(void 0, (text) => {
    if (noticeTimer.current) clearTimeout(noticeTimer.current)
    setNotice(text)
    noticeTimer.current = setTimeout(() => setNotice(null), exports.NOTICE_MS)
  }, [])
  _react.useEffect.call(void 0, () => () => { if (noticeTimer.current) clearTimeout(noticeTimer.current) }, [])
  const latest = _react.useRef.call(void 0, { value, fromTemplate, mode, maxLength, onTooLong })
  latest.current = { value, fromTemplate, mode, maxLength, onTooLong }

  // Sending or clearing the draft ends the template, and its gate with it.
  _react.useEffect.call(void 0, () => { if (!value && fromTemplate) setFromTemplate(false) }, [value, fromTemplate, setFromTemplate])
  // The "/" picker closes once the draft no longer starts with "/".
  _react.useEffect.call(void 0, () => { if (mode === 'slash' && !value.startsWith('/')) setMode(null) }, [mode, value])
  // Another chat (the screen isn't remounted for it) closes the picker, so a
  // pick still fetching can't land in the new chat's draft.
  _react.useEffect.call(void 0, () => { setMode(null) }, [blobjectKey, orgKey])

  // Enter or Send with something left jumps to the first value to fill (or
  // the stray "{{") and flashes it, instead of doing nothing.
  const [flash, setFlash] = _react.useState(null)
  const flashTimer = _react.useRef(null)
  _react.useEffect.call(void 0, () => () => { if (flashTimer.current) clearTimeout(flashTimer.current) }, [])
  // An edit moves the text under it, so the flash ends.
  _react.useEffect.call(void 0, () => setFlash(null), [value])
  const onBlockedSend = _react.useCallback.call(void 0, () => {
    const state = _templateComposer.templateFillState.call(void 0, latest.current.value, latest.current.fromTemplate)
    const target = state.kind === 'fill' ? state.first : state.kind === 'stray' ? state.at : null
    if (!target) return
    _optionalChain([composer, 'access', _ => _.current, 'optionalAccess', _2 => _2.select, 'call', _3 => _3(target)])
    if (flashTimer.current) clearTimeout(flashTimer.current)
    setFlash(target)
    flashTimer.current = setTimeout(() => setFlash(null), exports.FLASH_MS)
  }, [composer])

  // Handed to the composer as a prop, so a composer mounted later (Unarchive
  // swaps the archived bar for a new one) gets the gate too.
  const sendGate = _react.useMemo.call(void 0, () => {
    const block = _templateComposer.templateSendBlock.call(void 0, value, fromTemplate)
    return block.blocked ? { ...block, onBlockedSend } : undefined
  }, [value, fromTemplate, onBlockedSend])

  const fillState = _react.useMemo.call(void 0, () => _templateComposer.templateFillState.call(void 0, value, fromTemplate), [value, fromTemplate])
  const next = _react.useCallback.call(void 0, () => {
    const handle = composer.current
    if (!handle) return
    const range = _templateComposer.nextToFill.call(void 0, latest.current.value, latest.current.fromTemplate, handle.getSelection())
    if (range) handle.select(range)
  }, [composer])

  const close = _react.useCallback.call(void 0, () => {
    const wasDialog = latest.current.mode === 'dialog'
    setMode(null)
    if (wasDialog) _optionalChain([composer, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
  }, [composer])

  const openDialog = _react.useCallback.call(void 0, () => {
    setDialogQuery('')
    setMode('dialog')
  }, [])
  // From the "/" list: the "/query" draft becomes the dialog's search.
  const manage = _react.useCallback.call(void 0, () => {
    const query = latest.current.value.slice(1)
    _optionalChain([composer, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.replaceDraft, 'call', _9 => _9('')])
    setDialogQuery(query)
    setMode('dialog')
  }, [composer])
  const onTypedTrigger = _react.useCallback.call(void 0, (trigger) => {
    if (trigger === '/') setMode('slash')
  }, [])
  const actionHandlers = _react.useMemo.call(void 0, () => ({ templates: openDialog }), [openDialog])

  const pick = _react.useCallback.call(void 0, (template, fill, pickNotice) => {
    const handle = composer.current
    if (!handle) return
    const inserted = _templateInsert.insertTemplate.call(void 0, '', { start: 0, end: 0 }, template.Body, fill)
    const slash = latest.current.mode === 'slash'
    const at = handle.getSelection()
    // From "/" the template replaces the "/query" draft; otherwise it goes
    // over the selection.
    const length = slash
      ? inserted.text.length
      : latest.current.value.length - Math.abs(at.end - at.start) + inserted.text.length
    if (length > latest.current.maxLength) {
      latest.current.onTooLong()
      return
    }
    if (slash) {
      handle.replaceDraft(inserted.text)
      handle.select(inserted.selection)
    } else {
      handle.insertAtCaret(inserted.text)
      const start = Math.min(at.start, at.end)
      handle.select({ start: start + inserted.selection.start, end: start + inserted.selection.end })
    }
    setFromTemplate(true)
    setMode(null)
    if (!slash) handle.focus()
    if (pickNotice) showNotice(pickNotice)
  }, [composer, setFromTemplate, showNotice])

  const onKeyDownFirst = _react.useCallback.call(void 0, (e) => {
    if (_optionalChain([pickerKeys, 'access', _10 => _10.current, 'optionalCall', _11 => _11(e)])) return true
    const handle = composer.current
    if (e.key !== 'Tab' || !latest.current.fromTemplate || !handle) return false
    const at = handle.getSelection()
    const chip = _templateComposer.nextChip.call(void 0, latest.current.value, at.start, e.shiftKey ? -1 : 1, at.end)
    if (!chip) return false
    e.preventDefault()
    handle.select(chip)
    return true
  }, [composer])

  const chips = _react.useMemo.call(void 0, () => {
    if (!fromTemplate) return NO_CHIPS
    const ranges = _templateComposer.chipRanges.call(void 0, value)
    if (!flash) return ranges
    // The stray "{{" isn't a chip, so it's drawn as one while it flashes.
    const flashed = ranges.some(r => r.start === flash.start && r.end === flash.end) ? ranges : [...ranges, flash]
    return flashed
      .map(r => (r.start === flash.start && r.end === flash.end ? { ...r, flash: true } : r))
      .sort((a, b) => a.start - b.start)
  }, [fromTemplate, value, flash])

  const picker = mode === 'slash' && orgKey
    ? (
      _react2.default.createElement(ComposerTemplatePicker, {
        orgKey: orgKey,
        blobjectKey: blobjectKey,
        draft: value,
        onPick: pick,
        onClose: close,
        onManage: manage,
        keys: pickerKeys, __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}
      )
    )
    : (
      _react2.default.createElement(_react2.default.Fragment, null
        ,  notice && _react2.default.createElement('div', { className: "composer-templates--notice", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}},  notice ) 
        , _react2.default.createElement(TemplateFillBar, { state: fillState, onNext: next, __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}} )
      )
      )

  // Rendered by the screen outside the composer, so the composer's own key
  // handling (its shortcuts, Esc clearing files) never sees the dialog's keys.
  const dialog = mode === 'dialog' && orgKey
    ? (
      _react2.default.createElement(_TemplatesDialog2.default, {
        orgKey: orgKey,
        blobjectKey: blobjectKey,
        initialQuery: dialogQuery,
        draft: fromTemplate ? '' : value,
        onInsert: pick,
        onClose: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
      )
    )
    : null

  return { actionHandlers, onTypedTrigger, onKeyDownFirst, chipRanges: chips, picker, dialog, sendGate }
}; exports.useComposerTemplates = useComposerTemplates

/* "ⓘ 2 to fill · Next ›" above the field while a template has values left,
 * or "Fix the {{ in your message · Go to it ›" for a stray brace: the same
 * bar, counts and order as mobile's. Hidden when nothing is left. */
const TemplateFillBar = ({ state, onNext }) => {
  // Acting on mousedown would move focus off the field; keep it there.
  const keepFocus = _react.useCallback.call(void 0, (e) => e.preventDefault(), [])
  const bar = _templateComposer.fillBarText.call(void 0, state)
  if (!bar) return null
  return (
    _react2.default.createElement('div', { className: "composer-templates--fill", 'data-testid': "template-fill-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}
      , _react2.default.createElement('span', { className: "composer-templates--fill-icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}}, "ⓘ")
      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 234}},  bar.text )
      , _react2.default.createElement('span', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}, "·")
      , _react2.default.createElement('button', { type: "button", className: "composer-templates--fill-next", 'aria-label': bar.label, onMouseDown: keepFocus, onClick: onNext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}
        ,  bar.action 
      )
    )
  )
}













/* The "/" list above the composer field: the field keeps focus and what
 * follows "/" is the query. */
const ComposerTemplatePicker = ({ orgKey, blobjectKey, draft, onPick, onClose, onManage, keys }) => {
  const query = draft.slice(1)
  const { rows, fill, fillFor, context, status } = _useTemplatePickerRows.useTemplatePickerRows.call(void 0, orgKey, blobjectKey, query)
  const [selected, setSelected] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, () => setSelected(0), [query])
  // A template that uses a patient's name, in a chat with several: who's it for?
  const [forTemplate, setForTemplate] = _react.useState(null)
  const [forNotice, setForNotice] = _react.useState(undefined)
  const [patientKey, setPatientKey] = _react.useState(null)
  // The latest version is fetched before inserting (a teammate may have just
  // edited or deleted it); a slow fetch shows a quiet loading state on its row.
  const { latest: fetchLatest, fetching, gone } = _useLatestTemplate.useLatestTemplate.call(void 0, orgKey)
  // What this chat fills a template with now. Read after the fetch, so a
  // change while it ran (the sending team, say) is what goes in.
  const current = _react.useRef.call(void 0, { blobjectKey, fill, context })
  current.current = { blobjectKey, fill, context }

  const choose = _react.useCallback.call(void 0, async (shown) => {
    const startedIn = current.current.blobjectKey
    const picked = await fetchLatest(shown)
    // Gone, closed, or another chat, while it fetched: insert nothing.
    if (!picked || current.current.blobjectKey !== startedIn) return
    const { template, notice } = picked
    const now = current.current
    if (_templateResolver.needsPatientChoice.call(void 0, template.Body, now.context)) {
      setPatientKey(null)
      setForNotice(notice)
      setForTemplate(template)
    } else {
      onPick(template, now.fill, notice)
    }
  }, [fetchLatest, onPick])
  const insertFor = _react.useCallback.call(void 0, () => {
    if (forTemplate && patientKey) onPick(forTemplate, fillFor(patientKey), forNotice)
  }, [forTemplate, patientKey, onPick, fillFor, forNotice])
  const cancelFor = _react.useCallback.call(void 0, () => setForTemplate(null), [])

  const onListKey = _react.useCallback.call(void 0, 
    (e) => _TemplatePicker.handlePickerKey.call(void 0, e, rows, Math.min(selected, Math.max(rows.length - 1, 0)), setSelected, choose, onClose),
    [rows, selected, choose, onClose],
  )
  // While asking who it's for: arrows choose a patient, Enter inserts, Esc goes back.
  const onChoiceKey = _react.useCallback.call(void 0, (e) => {
    const patients = context.patients
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault()
      const at = patients.findIndex(p => p.PatientKey === patientKey)
      const next = at < 0 ? 0 : (at + (e.key === 'ArrowDown' ? 1 : patients.length - 1)) % patients.length
      setPatientKey(patients[next].PatientKey)
      return true
    }
    if (e.key === 'Enter') {
      e.preventDefault()
      insertFor()
      return true
    }
    if (e.key === 'Escape') {
      e.preventDefault()
      cancelFor()
      return true
    }
    return false
  }, [context.patients, patientKey, insertFor, cancelFor])
  const onKey = forTemplate ? onChoiceKey : onListKey

  // The composer field hands keys to the picker while it's open.
  _react.useEffect.call(void 0, () => {
    keys.current = onKey
    return () => { keys.current = null }
  }, [onKey, keys])

  return (
    _react2.default.createElement('div', { className: "composer-templates", __self: this, __source: {fileName: _jsxFileName, lineNumber: 329}}
      ,  forTemplate
        ? (
          _react2.default.createElement(PatientChoice, {
            template: forTemplate,
            patients: context.patients,
            chosen: patientKey,
            onChoose: setPatientKey,
            onInsert: insertFor,
            onCancel: cancelFor, __self: this, __source: {fileName: _jsxFileName, lineNumber: 332}}
          )
          )
        : (
          _react2.default.createElement(_react2.default.Fragment, null
            ,  gone && _react2.default.createElement('div', { className: "composer-templates--notice", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 343}},  gone ) 
            , _react2.default.createElement(_TemplatePicker2.default, {
              rows: rows,
              status: status,
              selectedIndex: selected,
              query: query,
              onPick: choose,
              onHover: setSelected,
              onManage: onManage,
              loading: fetching, __self: this, __source: {fileName: _jsxFileName, lineNumber: 344}}
            )
          )
          )
      
    )
  )
}










/* "Insert "Reminder" for: (•) Maria Lopez ( ) Leo Lopez": one choice fills
 * every name variable for that patient. Nothing is chosen at first. */
const PatientChoice = ({ template, patients, chosen, onChoose, onInsert, onCancel }) => {
  const titleId = `template-for-${template.TemplateKey}`
  // Buttons act on mousedown so the composer field keeps focus, as the rows do.
  const keepFocus = _react.useCallback.call(void 0, (e) => e.preventDefault(), [])
  const choose = _react.useCallback.call(void 0, (e) => onChoose(e.target.value ), [onChoose])
  return (
    _react2.default.createElement('div', { className: "composer-templates--for", __self: this, __source: {fileName: _jsxFileName, lineNumber: 378}}
      , _react2.default.createElement('div', { id: titleId, className: "composer-templates--for-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 379}}, "Insert \"" ,  template.Name , "\" for:" )
      , _react2.default.createElement('div', { role: "radiogroup", 'aria-labelledby': titleId, className: "composer-templates--for-patients", __self: this, __source: {fileName: _jsxFileName, lineNumber: 380}}
        ,  patients.map(p => (
          _react2.default.createElement('label', { key: p.PatientKey, className: "composer-templates--for-patient", __self: this, __source: {fileName: _jsxFileName, lineNumber: 382}}
            , _react2.default.createElement('input', {
              type: "radio",
              name: titleId,
              value: p.PatientKey,
              checked: chosen === p.PatientKey,
              onChange: choose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 383}}
            )
            ,  `${p.FirstName} ${p.LastName}`.trim() || 'Unnamed patient' 
          )
        ))
      )
      , _react2.default.createElement('div', { className: "composer-templates--for-buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 394}}
        , _react2.default.createElement('button', { type: "button", className: "blm-btn", disabled: !chosen, onMouseDown: keepFocus, onClick: onInsert, __self: this, __source: {fileName: _jsxFileName, lineNumber: 395}}, "Insert")
        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--outlined" , onMouseDown: keepFocus, onClick: onCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 396}}, "Cancel")
      )
    )
  )
}
